import { Button, Text } from "@kunduz/ui-atoms";
import { trackEvent } from "@kunduz/utility-analytics";
import Link from "next/link";
import React, { ReactElement } from "react";

export const DynamicHeroButtonItem = (props: Props): ReactElement => {
  const { item } = props;

  function handleClicked(label?: string) {
    trackEvent("Hero Component CTA Button Clicked", {
      label,
    });
  }

  return (
    <Button
      variant="secondary"
      color="gray"
      size="sm"
      as={Link}
      href={item.url}
      onClick={() => handleClicked(item.label)}
    >
      <Text variant="textsm" weight="semibold">
        {item.label}
      </Text>
    </Button>
  );
};

interface Props {
  item: any;
}
